






















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItem } from "../../../domain/document/items";
import { Point } from "../../../domain/drawing";
import {
  IDrawableItemEditable,
} from ".";
import ObjectMenu from "./ObjectMenu.vue";
import { DocumentPageEditorContextMenuMixin } from "./mixins";

@Component({
  components: {
    ObjectMenu,
  },
})
export default class DrawableObjectMenu extends Mixins(DocumentPageEditorContextMenuMixin) {
  @Prop()
  focusedSource: IDrawableItemEditable;

  @Prop()
  isInputMethodSelectable: boolean;

  @Prop()
  isImageRegistrationEnable: boolean;

  mounted(): void {
    // メニュー以外をクリックした場合クローズできるようwindowにイベントを追加
    window.addEventListener("pointerdown", this.onWindowMouseDowned, false);
  }

  onWindowMouseDowned(): void {
    this.source = null;
  }

  destroyed(): void {
    window.removeEventListener("pointerdown", this.onWindowMouseDowned, false);
  }

  onMenuClick() {
    // 親のmousedownイベントでフォーカスが失われるトリガがあるため、親への通知を止めたうえでメニュークローズのトリガをクリックにも追加
    this.source = null;
  }

  get shownSource(): IDrawableItemEditable {
    // 同じ種別のobjectの場合object-menuのcomponentが使い回されて表示時の初期化ができない.非表示になったら一旦nullにする.
    return this.shouldShow
      ? this.lastSource
      : null;
  }

  handleObjectMouseClicked(source: IDrawableItemEditable, event: PointerEvent): void {
    this.source = null;
    if (event.button === 2) {
      this.updateLocation(event);
      this.size = this.emptyThresholdSize;  // 一旦非表示にする.表示されない閾値のサイズに一旦更新する.
      setTimeout(() => {
        if (!!this.focusedSource && this.focusedSource === source) {
          this.source = source;
          this.lastSource = source;
          this.updateSize();
        }
      }, 500);
    }
  }

  data(): any {
    return {
      previousMouseLocations: [] as Point[],
      source: null,
      lastSource: null,
    };
  }
  previousMouseLocations: Point[];
  source: IDrawableItemEditable;
  lastSource: IDrawableItemEditable;

  get shouldShow(): boolean {
    return (this.shouldAlwaysShow || this.source)
        // メニューのコンテンツが表示されてるかの情報がないので、サイズで判断する.閾値より小さければなしと判断する.
        && this.isVisibleSize;
  }

  get shouldAlwaysShow(): boolean {
    return this.$configuration.debug.shouldAlwaysShowObjectMenu;
  }

  @Watch("focusedSource")
  onFocusedSourceUpdated(newValue: IDrawableItemEditable): void {
    if (!newValue) {
      this.source = null;
    }
  }

  get focusedItem(): IDrawableItem {
    return this.focusedSource
      ? this.focusedSource.editingSource
      : null;
  }

  get isRemovable(): boolean {
    return this.isItemRemovable(this.focusedItem);
  }

  remove(): void {
    this.removeItem(this.focusedItem);
  }
}
